import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, JhiLanguageService } from 'ng-jhipster';

import { Reservation } from './reservation.model';
import { ReservationPopupService } from './reservation-popup.service';
import { ReservationService } from './reservation.service';
import { CRUD_ACTIONS } from '../../shared/index';

@Component({
    selector: 'jhi-reservation-delete-dialog',
    templateUrl: './reservation-delete-dialog.component.html'
})
export class ReservationDeleteDialogComponent {

    reservation: Reservation;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private reservationService: ReservationService,
        public activeModal: NgbActiveModal,
        private eventManager: EventManager
    ) {}

    clear() {
        this.activeModal.dismiss('cancel');
    }

    confirmDelete(id: number) {
        this.reservationService.delete(id).subscribe(response => {
            this.eventManager.broadcast({
                name: 'reservationListModification',
                content: {
                    action: CRUD_ACTIONS.DELETE,
                    content: {id: id}
                }
            });
            this.activeModal.dismiss(true);
        });
    }
}

@Component({
    selector: 'jhi-reservation-delete-popup',
    template: ''
})
export class ReservationDeletePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private reservationPopupService: ReservationPopupService
    ) { }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            this.modalRef = this.reservationPopupService
                .open(ReservationDeleteDialogComponent as Component, params['id']);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/reservation/reservation-delete-dialog.component.ts